export class DocumentInput {
  public pdfFileRequired: boolean; // Determines wether we must generate a PDF from the document
  public file: Blob; // The document file (created from a template).
  public format: string; // The document format, the default value is RTF.
  public description: string; // The document description (Template description).
  public guid?: string;
  public version?: number; // The document version, use 1 as default value.
  public userContactId?: number; // The contact ID of the connected user
  public modeleId?: number;
  public attachmentIds: string;
  constructor(data?: Partial<DocumentInput>) {
    Object.assign(this, data);
  }
}
